import { ButtonMantine, ButtonProps } from 'ui';

import { useUserTokenExFormContext } from './FormContext';

type Props = {
  onClick: () => void;
  label?: string;
  color?: ButtonProps['color'];
  variant?: ButtonProps['variant'];
};
// This could just be included in the parent but thought there may be at ime where a different method is used?
const SubmitButton = ({ onClick, label = 'Add My Card', color, variant }: Props) => {
  const form = useUserTokenExFormContext();
  return (
    <ButtonMantine
      disabled={!form.isValid()}
      onClick={onClick}
      c={color}
      variant={variant}
      fullWidth
    >
      {label}
    </ButtonMantine>
  );
};

export { SubmitButton };
